import { Typography } from "@avenue-8/sidekick-ui";
import { IErrorWidget } from "./types/ErrorWidget";
import { Box } from "@mui/material";
import { ChatWidgetNavbar } from "../ChatWidgetNavbar";

type Props = {
  widget: IErrorWidget;
};

export const ErrorWidget = (props: Props) => {
  const { errorMessage, errorDescription } = props.widget;
  return (
    <Box>
      <ChatWidgetNavbar>
        <Typography variant="subtitle1">Error</Typography>
      </ChatWidgetNavbar>
      <Typography variant="h6" textAlign={"center"} padding={4}>
        {errorMessage}
      </Typography>
      {errorDescription && (
        <Typography variant="body2" textAlign={"center"} padding={2}>
          {errorDescription}
        </Typography>
      )}
    </Box>
  );
};
